module.exports = __webpack_public_path__ + "static/og-a6e44c48894d93df6132ecb071e38863.png";